import { useMutation } from 'react-query';
import { api } from 'services/api';
import Cookies from 'js-cookie';
import {
  GET_IN_AUTH_TOKEN_COOKIE_KEY,
  GET_IN_USER_COOKIE_KEY,
} from 'utils/constants';
import { UserProps } from 'hooks/use-auth';

export type LoginResponse = {
  access_token: string;
};

type GetUserProps = {
  status: number;
  data: UserProps;
};

export const getUser = async (): Promise<GetUserProps> => {
  const { status, data } = await api.get('/auth/v2/me');

  if (status === 200) {
    Cookies.set(GET_IN_USER_COOKIE_KEY, JSON.stringify(data.data));
  }

  return {
    status,
    data: data.data,
  };
};

export const updateUser = async (
  user: Partial<UserProps>
): Promise<{
  status: number;
  data: UserProps;
}> => {
  const { status, data } = await api.put(`/auth/v3/users/${user.id}`, {
    ...user,
  });

  if (status === 200) {
    Cookies.set(GET_IN_USER_COOKIE_KEY, JSON.stringify(data.data));
  }

  return {
    status,
    data: data.data,
  };
};

export const useUpdateUser = () => {
  return useMutation('updateUser', (user: Partial<UserProps>) =>
    updateUser(user)
  );
};

type UseLoginByEmailParams = {
  email?: string;
  mobile?: string;
};

export interface IWriteResponseLogin {
  status: number;
  session: string;
  access_token?: string;
  waiting_time?: number;
}

type LoginProps = {
  status: number;
  data: IWriteResponseLogin;
};

interface IWriteData {
  currentFlow: 'sms' | 'email';
  params: UseLoginByEmailParams;
}

export const login = async (data: IWriteData): Promise<LoginProps> => {
  const { status, data: response } = await api.post(
    `/auth/v3/${data.currentFlow}/session`,
    {
      ...data.params,
    }
  );

  if (status === 200) {
    if (response.data.access_token) {
      Cookies.set(GET_IN_AUTH_TOKEN_COOKIE_KEY, response.data.access_token);
      await getUser();
    }
  }

  return {
    status,
    data: {
      ...response.data,
    },
  };
};

export const useLogin = () => {
  return useMutation('login', (params: IWriteData) => login(params));
};
